import { PAGINATION_LIMIT, RESOURCE } from '@src/constants';
import { AFFILIATE_TRANSACTION_STATUS } from '@src/constants/affiliate';
import api from './api';

const AFFILIATE_TRANSACTION_V2 = '/affiliate-transactions';

// ---------------------------------------------------------------------------
// v1 (legacy) - used by the old PaymentRequestDrawer and the transaction list
// ---------------------------------------------------------------------------
const createAffiliateTransaction = async ({
  fullName,
  phoneNumber,
  email,
  withTheAmount,
  address,
  bankName,
  bankAccountNumber,
  bankAccountOwner,
  files,
}) => {
  const response = await api({
    method: 'POST',
    url: RESOURCE.AFFILIATE_TRANSACTION,
    data: {
      bank: {
        name: bankName,
        accountNumber: bankAccountNumber,
        accountOwner: bankAccountOwner,
      },
      user: {
        name: fullName,
        email,
        phoneNumber,
        address,
      },
      money: withTheAmount,
      images: files,
    },
  });
  return response;
};

const getAffiliateTransaction = async ({
  userId,
  packageLevel,
  packageStatus,
  type,
  startDate,
  endDate,
  search,
  searchFields,
  offset,
  limit = PAGINATION_LIMIT,
  fields,
  sort,
  status,
}) => {
  const response = await api({
    method: 'GET',
    url: RESOURCE.AFFILIATE_TRANSACTION,
    params: {
      userId,
      packageLevel,
      packageStatus,
      type,
      startDate,
      endDate,
      search,
      searchFields,
      offset,
      limit,
      fields,
      sort,
      status,
    },
  });

  return response;
};

// ---------------------------------------------------------------------------
// v2 - mirrors the voice-revenue withdrawal flow (/affiliate-transactions)
// ---------------------------------------------------------------------------
const createAffiliateTransactionRequest = async (data) => {
  const response = await api({
    method: 'POST',
    url: AFFILIATE_TRANSACTION_V2,
    data,
  });
  return response;
};

const getInProcessingAffiliateTransaction = async () => {
  const response = await api({
    method: 'GET',
    url: `${AFFILIATE_TRANSACTION_V2}/in-processing`,
  });
  return response;
};

const getPaidAffiliateTransaction = async () => {
  const response = await api({
    method: 'GET',
    url: AFFILIATE_TRANSACTION_V2,
    params: { status: AFFILIATE_TRANSACTION_STATUS.PAID, offset: 0, limit: 1 },
  });
  return response;
};

const cancelAffiliateTransaction = async (transactionId) => {
  const response = await api({
    method: 'POST',
    url: `${AFFILIATE_TRANSACTION_V2}/${transactionId}/cancel`,
  });
  return response;
};

// Returns the marketer's requests across both flows (v1 + v2), masked.
const getAffiliateTransactionRequests = async ({ offset, limit, sort }) => {
  const response = await api({
    method: 'GET',
    url: AFFILIATE_TRANSACTION_V2,
    params: { offset, limit, sort },
  });
  return response;
};

export {
  createAffiliateTransaction,
  getAffiliateTransaction,
  createAffiliateTransactionRequest,
  getInProcessingAffiliateTransaction,
  getPaidAffiliateTransaction,
  cancelAffiliateTransaction,
  getAffiliateTransactionRequests,
};
